import { render, staticRenderFns } from "./FabricAdditionCreateEdit.vue?vue&type=template&id=09ff305e&scoped=true&"
import script from "./FabricAdditionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricAdditionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricAdditionCreateEdit.vue?vue&type=style&index=0&id=09ff305e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff305e",
  null
  
)

export default component.exports